import { render, staticRenderFns } from "./page-date.vue?vue&type=template&id=ca736aa8&"
import script from "./page-date.vue?vue&type=script&lang=js&"
export * from "./page-date.vue?vue&type=script&lang=js&"
import style0 from "./page-date.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports